import React from 'react';
import { Row, Col } from 'antd';
import { Link } from 'react-router-dom';

import '../../assets/css/publicaciones.css';

const DocumentoNoDisponible = ({ titulo, tipo = 'capítulo' }) => (
  <Row>
    <Col span={24}>
      <p className="titulo_revista_reportes">{titulo}</p>
    </Col>
    <Col span={20} offset={2}>
      <div
        style={{
          textAlign: 'center',
          padding: '80px 20px',
          color: '#444',
          fontFamily: 'system-ui, sans-serif',
        }}
      >
        <h2 style={{ marginBottom: 16 }}>Este {tipo} ya no está disponible</h2>
        <p style={{ fontSize: 16, color: '#666', maxWidth: 520, margin: '0 auto 32px' }}>
          El documento fue retirado. Puedes consultar nuestras publicaciones más
          recientes en las siguientes ediciones del compendio estadístico.
        </p>
        <div style={{ display: 'flex', justifyContent: 'center', gap: 12, flexWrap: 'wrap' }}>
          <Link to="/compendio-estadistico-2024-2025" className="btn-amarillo boton-amarillo">
            Compendio 2024-2025
          </Link>
          <Link to="/compendio-estadistico-2022-2023" className="btn-amarillo boton-amarillo">
            Compendio 2022-2023
          </Link>
          <Link to="/compendio-estadistico-completo" className="btn-amarillo boton-amarillo">
            Compendio 2017-2021
          </Link>
        </div>
      </div>
    </Col>
  </Row>
);

export default DocumentoNoDisponible;
